import { languageHelper } from "../../../config/helperFunctions";
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { apiKey } from '../../../config/config'

function CopyItem() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [data, setData] = useState([])

  useEffect(() => {
    axios.get(`${apiKey}/api/rms/admin/categories`, {
      headers: {
        Authorization: `Bearer ${user?.token}`,
      },
    })
      .then((res) => {
        setData(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [user.token])


  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div>
          <h1 className="text-[#7B20C7] text-2xl font-semibold py-5">{languageHelper("Categories")}</h1>
        </div>
        <div className="flex flex-wrap gap-6">
          {data.map((item) => (
              <Link to={`products/${item.id}`} className="border-solid border-2 border-[#7B20C7] p-6 cursor-pointer rounded-2xl w-36 hover:transition-all hover:bg-[#7B20C7] group ">
                <div>
                  <h1 className="flex justify-center align-middle   text-md font-semibold
                 group-hover:text-white ">{item.category_name}</h1>
                </div>
              </Link>
            ))}
        </div>
      </div>
    </main>
  )
}

export default CopyItem
